{
  "invalidSelection": "Izbrano {selectedCount, plural, one {date} other {dates}} ni na voljo."
}
